function getVisitId(){              //wykorzystywane tylko przez EURO, można by przenieść na stronę EURO
	var x = $.cookie('euroVisit') || "adblock";
	x=x.indexOf('::')>-1 ? x.split("::") : x.split("|");
	if(x.length>1){
		return x[x.length-3];
	}
	else{
		return x[0];
	}
}
function getCustomerId() {          //wykorzystywane tylko przez EURO, można by przenieść na stronę EURO
	var x = $.cookie('euroCustomer') || "adblock";
	if(x.length>1){
		return x.substring(0, x.indexOf('|'));
	}
	else{
		return "0";
	}
}

euro = {
	getVisitId:function() {
		window.getVisitId();
	},
	getCustomerId:function() {
		window.getCustomerId();
	},
	shopEventLog: function(params) {
		app.logEvent(params);
	},
	setUserId: function(id) {
		window.setUserId(id);
	},
	getUserId : function() {
		return window.getUserId();
	},
	addProductByPlu: function(productPlu, withParams){

		if(typeof productPlu === "undefined")
			return;

		if(typeof withParams === "undefined")
			withParams = {};

		$.ajax({
			url: '/product-code-to-id.ltr',
			dataType: 'json',
			async: false,
			data: {
				productPlu: productPlu
			},
			success: function(data) {
				$.extend(true,data,withParams);
				app.addProduct(data);
			}
		});
	},
	log:{
		//nieobsługiwane juz przez UNITY
	},
	shouldDisplayNewLabelsStyle:function(){
		//nadpisywane przez Euro
	},
	logAddToCardSuccessEvent: function(obj){
		//nadpisywane przez Euro
	}
};

function kalkulatorCreditAgricoleEvents(obj){
	//nadpisywane przez Euro
}
